import moment from "moment";
import { NumericFormat } from "react-number-format";
import { FixedCell } from "../../../components/tables/StandardTable";
import { DateDisplay } from "../../../components";

const AgedDebtorDetailTableRow = ({
    data,
    index,
    style: { height, width }
}) => {
    const {
        groupId,
        originalFeeDate,
        feeTypeDescription,
        ///providerId,
        provider,
        sales,
        debt,
        masterAccountReference,
        masterAccountName,
        applicationReferenceId,
        applicationDescription
    } =data[index];//[2];//= data[index];

    //console.log('row data[',index,']',data[index]);

    ///console.log('groupId in row', groupId);

    return (
            <tr style={{ height, width }}>
                <FixedCell width={7.5} className="text-truncate">{moment(originalFeeDate).isValid() ? <DateDisplay>{originalFeeDate}</DateDisplay> : <span className="px-2">-</span>}</FixedCell>
                <FixedCell width={10} className="text-truncate">{feeTypeDescription}</FixedCell>
                <FixedCell width={15} className="text-truncate">{provider}</FixedCell>
                <FixedCell width={10} className="text-truncate">
                    <NumericFormat
                        displayType="text"
                        value={sales}
                        thousandSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix="£"
                    />
                </FixedCell>
                <FixedCell width={10} className="text-truncate">
                    <NumericFormat
                        displayType="text"
                        value={debt}
                        thousandSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix="£"
                    />
                </FixedCell>
                <FixedCell width={15} className="text-truncate">{masterAccountReference} - {masterAccountName}</FixedCell>
                <FixedCell width={10} className="text-truncate">{applicationReferenceId}</FixedCell>
                <FixedCell width={20} className="text-truncate">{applicationDescription}</FixedCell>
                {/*<FixedCell width={2.5} className="text-truncate">
                    <DebtorTableRowActionCol
                        setChosenGrouping={() => setChosenGrouping(groupId)}
                    />
                </FixedCell>*/}
            </tr >
        );

};

export default AgedDebtorDetailTableRow;